import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { Paging } from 'projects/patient/src/app/core/types/helper.model';
import { AppoimentService } from '../appoinmnet-Booking/appoinment-services/appoiment.service';
import { Appointment, AppointmentResponse } from '../appoinmnet-Booking/appoinment-const/appoinment-model';
import { Tag } from 'primeng/tag';
import { Avatar } from 'primeng/avatar';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { JitsiServicesService } from '../../../jitsi-meeting/jitsi-services/jitsi-services.service';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';
import { SidebarService } from 'projects/patient/src/app/core/services/sidebar.service';

export interface UpcomingItem {
  doctorName: string;
  title: string;
  date: string; // formatted
  time: string; // formatted
  status: 'Upcoming' | 'Completed' | 'Cancelled';
}

@Component({
  selector: 'patient-upcoming-appointments',
  standalone: true,
  imports: [CommonModule, SidebarModule, Tag, Avatar, Card, Button],
  templateUrl: './upcoming-appointments.component.html',
  styleUrls: ['./upcoming-appointments.component.scss'],
})
export class UpcomingAppointmentsComponent {
  @Input() items: UpcomingItem[] = [];
  // @Output() appointmentClick = new EventEmitter<UpcomingItem>();

  appointments: Appointment[] = [];
  patientId!: string;

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
  };

  constructor(
    private router: Router,
    private sidebarService: SidebarService,
    private _appointmentService: AppoimentService,
    private jitsiService: JitsiServicesService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.authService.getUserProfile().subscribe((res) => {
      if (res.PatientId) {
        this.patientId = res.PatientId;
        this.getAppointments();
      }
      console.log(this.patientId, ' this is patient id from local storage');
    });
  }

  selectedAppt: any = null;
  sidebarVisible: boolean = false;

  // onClick(item: any) {
  //   // this.selectedAppt = appt;
  //   // this.sidebarVisible = true;
  //   this.sidebarService.showSidebar(item);
  // }

  joinAppointment(appointment: Appointment) {
    console.log(appointment);

    const payload = {
      appointment_id: appointment.appointment_id,
      user_name: appointment.patient_name, // user name  a
      user_email: 'patient@email.com',
      is_moderator: false,
    };

    this.jitsiService.generateJitsiToken(payload).subscribe((res) => {
      const meetingConfig = {
        roomName: `appointment${appointment.appointment_id}`,
        token: res.access_token,
        displayName: appointment.patient_name,
        domain: 'jitsi.certifyleads.in',
      };

      console.log(meetingConfig);


      this.router.navigate(['/meeting'], {
        state: meetingConfig,
      });
    });
  }

  getAppointments() {
    this.paging.filter = `patient_id eq ${this.patientId} and appointment_status eq 105`;

    this._appointmentService.getAppointmentsByPatient(this.paging).subscribe({
      next: (res: AppointmentResponse) => {
        this.appointments = res.data;
        console.log(this.appointments);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
